import { Helmet, HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";

interface SeoHelmetProps {
  titleKey: string;
  descriptionKey: string;
  keywordsKey: string;
  authorKey: string;
  type?: string;
  prioritizeSeoTags?: boolean;
  name?: string;
  surname?: string;
}

export default function SeoHelmet({
  titleKey,
  descriptionKey,
  keywordsKey,
  authorKey,
  type = "website",
  name,
  surname,
}: SeoHelmetProps) {
  const { t } = useTranslation();

  const title = t(titleKey, { name, surname });
  const description = t(descriptionKey, { name, surname });
  const keywords = t(keywordsKey);
  const author = t(authorKey);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <meta property="og:type" content={type} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Helmet>
    </HelmetProvider>
  );
}
